import React from 'react';
import FitoImage from '../molecules/fito-image.molecule';
import CustomText from '../atoms/custom-text.atom';
import CustomButton from '../atoms/custom-button.atom';
import PropTypes from 'prop-types';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '16px',
    height: '100vh',
    minHeight: 'inherit',
  },
  imageContainer: {
    width: '130px',
    height: '130px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center'
  },
  textCenter: {
    textAlign: 'center'
  }
};

export const RepeatedAccountTemplate = ({ phoneNumber, handlePress }) => {
  return (
    <div style={styles.container}>
      <div style={{flexGrow: 1}}/>
      <CustomText variant="headline4xl" style={styles.textCenter}>
        Ya tienes una cuenta registrada
      </CustomText>
      <CustomText variant="headlineLg" style={styles.textCenter}>
        {`Tu CURP ya está asociado a una cuenta con el número **-****-${phoneNumber.slice(-4)}`}
      </CustomText>
      <div style={{flexGrow: 1}}/>
      <div style={styles.imageContainer}>
        <FitoImage emotion="surprised" style={{width: '150px', height: '150px'}} />
      </div>
      {/* <div style={{flexGrow: 1}}/> */}
      <div style={{...styles.container, flexGrow: 1, height: 'auto'}}>
        <CustomText variant="headlineLg" style={styles.textCenter}>
          Para continuar, inicia sesión con ese número en la app
        </CustomText>
        <CustomButton variant='yellow'  onClick={handlePress}>Terminar proceso</CustomButton>
      </div>
      <div style={styles.textContainer}>
        <CustomText variant="caption" style={styles.textCenter}>
          ¿No tienes acceso a ese número? Contacta a nuestro equipo de soporte
          para recibir ayuda
        </CustomText>
      </div>
      <div style={{flexGrow: 1}}/>
    </div>
  );
};

RepeatedAccountTemplate.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  handlePress: PropTypes.func.isRequired
}; 